import React, {PureComponent} from "react";
import {connect} from "react-redux";
import AuthorizationService from "../Models/AuthorizationService";

export default function Authorization(allowedPermission) {
    return (WrappedComponent) => {
        class WithAuthorization extends PureComponent {
            render() {
                const {employee, permission, dispatch, ...rest} = this.props

                return AuthorizationService.isAuthorized(employee, permission || allowedPermission) ?
                       <WrappedComponent {...rest} /> : <span></span>
            }
        }

        return connect(
          state => ({
              employee: state.employee
          })
        )(WithAuthorization)
    }
}
